import { BaseApiClient } from './base-client'
import { API_ROUTES, ApiResponse } from '@super/shared-types'
import type {
  PropertyResolutionPlan,
  PropertyResolutionResponse,
  PropertyValidationResponse,
} from '@super/shared-types'

export type {
  PropertyResolutionData,
  PropertyResolutionPlan,
  PropertyResolutionResponse,
  PropertyValidationError,
  PropertyValidationWarning,
  PropertyValidationResponse,
} from '@super/shared-types'

export interface PropertyResolutionRequest {
  propertyResolutionPlan: PropertyResolutionPlan
  companyId: string
  options?: {
    updateExisting?: boolean
    continueOnError?: boolean
  }
}

export class PropertyResolutionApiClient extends BaseApiClient {
  async executePropertyResolution(
    request: PropertyResolutionRequest,
  ): Promise<PropertyResolutionResponse> {
    const response = await this.request<
      ApiResponse<PropertyResolutionResponse>
    >(API_ROUTES.PROPERTY_RESOLUTION.EXECUTE, {
      method: 'POST',
      body: JSON.stringify(request),
    })
    if (!response.data) {
      throw new Error('No data returned from property resolution')
    }
    return response.data
  }

  async validatePropertyResolution(
    request: PropertyResolutionRequest,
  ): Promise<PropertyValidationResponse> {
    const response = await this.request<PropertyValidationResponse>(
      API_ROUTES.PROPERTY_RESOLUTION.VALIDATE,
      { method: 'POST', body: JSON.stringify(request) },
    )
    return response
  }
}

export const propertyResolutionApiClient = new PropertyResolutionApiClient()
